import miniGameOrderOverviewLoseBg0 from "@gameAssets/minigame/mini-game-order-overview-lose-bg-0.png";
import miniGameOrderOverviewLoseBg1 from "@gameAssets/minigame/mini-game-order-overview-lose-bg-1.png";
import miniGameOrderOverviewLoseBg2 from "@gameAssets/minigame/mini-game-order-overview-lose-bg-2.png";
import miniGameOrderOverviewWinBg0 from "@gameAssets/minigame/mini-game-order-overview-win-bg-0.png";
import miniGameOrderOverviewWinBg1 from "@gameAssets/minigame/mini-game-order-overview-win-bg-1.png";
import miniGameOrderOverviewWinBg2 from "@gameAssets/minigame/mini-game-order-overview-win-bg-2.png";

const IMAGES_WIN = [
  miniGameOrderOverviewWinBg0,
  miniGameOrderOverviewWinBg1,
  miniGameOrderOverviewWinBg2,
];

const IMAGES_LOSE = [
  miniGameOrderOverviewLoseBg0,
  miniGameOrderOverviewLoseBg1,
  miniGameOrderOverviewLoseBg2,
];

export function miniGameOrderOverviewRandomImage(win: boolean): string {
  const images = win ? IMAGES_WIN : IMAGES_LOSE;
  const indexRandom = Math.floor(Math.random() * images.length);

  return images[indexRandom];
}
